import { LiveSidePanel } from './LiveSidePanel';
import { connectSidePanel } from './sidePanel.connect';

export const ConnectedSidePanel = connectSidePanel(LiveSidePanel);
